import Head from "next/head"
import { BlitzPage, Routes } from "@blitzjs/next"
import { useRouter } from "next/router"
import { useQuery } from "@blitzjs/rpc"
import Layout from "app/core/layouts/Layout"
import getCurrencies from "app/currencies/queries/getCurrencies"
import Suspense from "app/core/components/Suspense"

import Container from "@mui/material/Container"
import Paper from "@mui/material/Paper"
import Typography from "@mui/material/Typography"
import TableContainer from "@mui/material/TableContainer"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"

export const CurrenciesList = () => {
  const router = useRouter()
  const page = Number(router.query.page) || 0
  const [currencies] = useQuery(getCurrencies, {
    orderBy: { code: "asc" },
  })

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Code</TableCell>
            <TableCell>Name</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currencies.map((currency) => (
            <TableRow key={currency.id}>
              <TableCell>{currency.code}</TableCell>
              <TableCell>{currency.name}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

const CurrenciesPage: BlitzPage = () => {
  return (
    <>
      <Head>
        <title>Currencies</title>
      </Head>

      <Container maxWidth={false}>
        <Typography sx={{ my: 4 }} variant="h4" component="h2">
          Currencies
        </Typography>
        <Suspense>
          <CurrenciesList />
        </Suspense>
      </Container>
    </>
  )
}

CurrenciesPage.authenticate = true
CurrenciesPage.getLayout = (page) => <Layout>{page}</Layout>

export default CurrenciesPage
